module.exports = __webpack_public_path__ + "img/Airbnb-landing-Page-Working-From-Listing-1.c8252ba8.jpg";